"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
var react_1 = __importStar(require("react"));
var label_1 = __importDefault(require("react-rainbow-components/components/Input/label"));
var useReduxForm_1 = __importDefault(require("react-rainbow-components/libs/hooks/useReduxForm"));
var react_rainbow_components_1 = require("react-rainbow-components");
var hooks_1 = require("@rainbow-modules/hooks");
var jsoneditor_1 = __importDefault(require("jsoneditor"));
require("jsoneditor/dist/jsoneditor.css");
var styled_1 = require("./styled");
var debounce_1 = __importDefault(require("./debounce"));
var JsonInput = function (props) {
    var _a = useReduxForm_1.default(props), className = _a.className, style = _a.style, id = _a.id, value = _a.value, label = _a.label, labelAlignment = _a.labelAlignment, hideLabel = _a.hideLabel, required = _a.required, readOnly = _a.readOnly, disabled = _a.disabled, error = _a.error, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var editorRef = react_1.useRef();
    var containerRef = react_1.useRef(null);
    var labelId = hooks_1.useUniqueIdentifier('label');
    var editorId = hooks_1.useUniqueIdentifier('editor');
    var errorMessageId = hooks_1.useUniqueIdentifier('error');
    var _b = react_1.useState(), isFocused = _b[0], setIsFocused = _b[1];
    var setEditorValue = function (newValue) {
        if (editorRef.current) {
            if (!newValue) {
                editorRef.current.update({});
            }
            else if (typeof newValue === 'string') {
                editorRef.current.updateText(newValue);
            }
            else {
                editorRef.current.update(newValue);
            }
        }
    };
    react_1.useEffect(function () {
        if (!containerRef.current)
            return;
        editorRef.current = new jsoneditor_1.default(containerRef.current, {
            mode: disabled || readOnly ? 'view' : 'code',
            mainMenuBar: false,
            navigationBar: false,
        });
        if (disabled || readOnly)
            editorRef.current.expandAll();
        // eslint-disable-next-line consistent-return
        return function () {
            if (editorRef.current) {
                editorRef.current.destroy();
                editorRef.current = undefined;
            }
        };
    }, [disabled, readOnly]);
    react_1.useEffect(function () { return setEditorValue(value); }, [value]);
    var fireOnChange = function (format) {
        if (format === void 0) { format = false; }
        if (typeof onChange === 'function' && editorRef.current) {
            try {
                var newValue = format
                    ? JSON.stringify(editorRef.current.get(), null, 2)
                    : editorRef.current.getText();
                onChange(newValue);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        }
    };
    var handleFocus = function (event) {
        setIsFocused(true);
        if (typeof onFocus === 'function')
            onFocus(event);
    };
    var handleBlur = function (event) {
        setIsFocused(false);
        fireOnChange(true);
        if (typeof onBlur === 'function')
            onBlur(event);
    };
    var handleLabelClick = function () {
        if (editorRef.current)
            editorRef.current.focus();
    };
    var handleKeyDown = debounce_1.default(function () { return fireOnChange(); }, 1000);
    var getLabelId = function () { return (label ? labelId : undefined); };
    var getErrorMessageId = function () { return (error ? errorMessageId : undefined); };
    return (react_1.default.createElement(styled_1.JsonInputContainer, { id: id, className: className, style: style },
        react_1.default.createElement("div", { onClick: handleLabelClick },
            react_1.default.createElement(label_1.default, { id: labelId, label: label, required: required, readOnly: readOnly, labelAlignment: labelAlignment, hideLabel: hideLabel, inputId: editorId })),
        react_1.default.createElement(styled_1.CodeEditorContainer, null,
            react_1.default.createElement(styled_1.CodeEditor, { id: editorId, role: "textbox", error: error, isFocused: isFocused, disabled: disabled, readOnly: readOnly, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: handleKeyDown, "aria-labelledby": getLabelId(), "aria-readonly": readOnly, "aria-required": required, "aria-multiline": true, ref: containerRef })),
        react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: error },
            react_1.default.createElement(styled_1.ErrorText, { id: getErrorMessageId() }, error))));
};
exports.default = JsonInput;
//# sourceMappingURL=index.js.map